import React from "react";
import {
  Page,
  Text,
  View,
  Document,
  StyleSheet,
  Image,
} from "@react-pdf/renderer";
import {
  margin,
  p1Styles,
  p2styles,
  p3styles,
  pad,
  styles,
} from "./styles/pdf2Style";

const Page1 = ({ QUOTATION }) => {
  console.log("QUOTTTT ", QUOTATION);
  return (
    <View style={styles.content}>
      <Text style={{ ...styles.textCenter, ...styles.bold }}>QUOTATION</Text>

      <View
        style={{
          ...styles.flex,
          ...styles.bold,
          justifyContent: "space-between",
        }}
      >
        <Text>Ref no: {QUOTATION?.reference_number}</Text>
        <Text>
          Date:{" "}
          {new Date().toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
          })}
        </Text>
      </View>

      <View style={styles.marginY10}>
        <Text style={styles.bold}>To,</Text>
        <View style={margin.mx20}>
          <Text>{QUOTATION?.client?.authorized_person_name}</Text>
          <Text>{QUOTATION?.client?.name}</Text>
          <Text>Riyadh, K.S.A.</Text>
        </View>
      </View>

      <View style={styles.marginY10}>
        <Text>Dear Sir,</Text>
        <Text>
          Thank you for having trusted us and giving an opportunity to server
          you.
        </Text>
      </View>

      <View style={[styles.flex]}>
        <Text style={styles.bold}>First Party: </Text>
        <Text> {QUOTATION?.company?.name} </Text>
      </View>
      <View style={[styles.flex]}>
        <Text style={styles.bold}>Second Party: </Text>
        <Text> {QUOTATION?.client?.name}</Text>
      </View>

      <Text style={[margin.mt20, styles.bold, styles.underline]}>
        Proposal – Cost Plus Quotation:
      </Text>
      <Text style={margin.mt12}>
        All the costs shall be charged in full to the Second Party at the time
        of respective ID expense. Detailed tables (Table 1 & Table 2) given
        below. Monthly Service fee includes only Saudization, Admin cost &
        service fee. There are no hidden charges, all the charges shall be
        invoiced at actuals.
      </Text>
      <Text style={margin.mt12}>
        The rates provided below are subject to change as per further amendments
        in current laws or new laws introduced by the KSA government, changes in
        Nitaqat percentage slabs, changes in taxes that affect our cost (for
        example VAT, Saudi minimum salary etc.) shall be applied & charged to
        Second Party at actuals. First Party shall provide written notice to
        Second Party for the changes.
      </Text>
      <Text style={margin.mt12}>
        **GoSI, Service Fee will be calculated for full month irrespective of
        attendance of the employee.
      </Text>
      <Text style={margin.mt12}>
        **All the costs including but not limited to Sponsorship Transfer fee,
        Iqama & work-permit fee, iqama processing fee, Insurance, iqama
        printing, ERE fee, Vacation air ticket, Vacation salary, end of service
        benefits, Baladiya, Ajeer, ATM costs, SCE accreditation fee, iqama
        profession change fee, any violations (iqama expiry, traffic etc.) and
        all other expenses related to employee shall be invoiced by the First
        party & the same shall borne by the Second Party, all actuals, in full.
      </Text>
    </View>
  );
};

export default Page1;
